var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4324_36444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2652 17.0549C32.2652 8.17003 25.2383 0.967407 16.5701 0.967407C7.90195 0.967407 0.875 8.17003 0.875 17.0549C0.875 25.9398 7.90195 33.1424 16.5701 33.1424C25.2383 33.1424 32.2652 25.9398 32.2652 17.0549Z",
    fill: "#ECECF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.57 10.1112C19.0918 10.1113 21.1305 12.2016 21.1305 14.7864C21.1304 16.0063 20.5676 17.5039 19.7628 18.996C18.9682 20.4692 17.9835 21.8558 17.2334 22.8326C16.8853 23.2858 16.254 23.2859 15.9058 22.8326C15.1558 21.8558 14.171 20.4692 13.3764 18.996C12.5717 17.5039 12.0089 16.0063 12.0088 14.7864C12.0088 12.2015 14.0481 10.1112 16.57 10.1112Z",
    stroke: "#0E1318",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5761 15.8863C17.1688 15.8863 17.6493 15.3938 17.6493 14.7863C17.6493 14.1788 17.1688 13.6863 16.5761 13.6863C15.9834 13.6863 15.5029 14.1788 15.5029 14.7863C15.5029 15.3938 15.9834 15.8863 16.5761 15.8863Z",
    stroke: "#0E1318"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4324_36444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.0703125 0.554932)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.10dae96cf930eee7877403233f2d91f4.svg";
export { ForwardRef as ReactComponent };